import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Table,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Badge,
  Tooltip,
} from "reactstrap";
import classnames from "classnames";
import { useParams } from "react-router";
import { authHeader } from "../../../functions/CoreFunctions";
import {
  GET_USER,
  ENDUSER_LICENSE_DETAILS,
  GET_PAYMENT,
} from "../../../constants/ApiPaths";
import API from "../../../redux/actions/API";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import { useNavigate, Link } from "react-router-dom";
import defaultAvatar from "../../../constants/Images/defaultAvatar-1.png";
import Pagination from "react-js-pagination";
import MyDog from "./MyDog";
import CustomTableEmptyRecord from "../../common/CustomTableEmptyRecord";
import { GUEST_USER_LICENSE } from "../../../constants/RoutePaths";
import BackButtonSvg from "../../common/BackButtonSvg";
import { Info } from "../../common/Info";
import { useSelector } from "react-redux";

function GuestDetails(props) {
  const [activeTab, setActiveTab] = useState("1");
  const { userId } = useParams();
  const history = useNavigate();
  const [details, setDetails] = useState({});
  const [licensetotalrecords, setlicensetotalrecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [licenseDetails, setlicenseDetails] = useState([]);
  const [currentpage, setCurrentPage] = useState(0);
  const [paymentCurrentpage, setpaymentCurrentpage] = useState(0);
  const [paymentDetails, setpaymentDetails] = useState([]);
  const [paymentDetailsCount, setpaymentDetailsCount] = useState(0);
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const Delete = useSelector((state) => state.Agencydelete);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  let GetUser = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_USER,
      headers: authHeader(),
      params: {
        userId: userId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setDetails(data);
      }
    } catch (error) {
     
    } finally {
      setLoading(false);
    }
  };

  let GetCustomer = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: ENDUSER_LICENSE_DETAILS,
      headers: authHeader(),
      params: {
        userId: userId,
        offset: currentpage,
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setlicenseDetails(data);
        setlicensetotalrecords(totalCount);
      }
    } catch (error) {
    
    } finally {
      setLoading(false);
    }
  };

  let GetPayment = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_PAYMENT,
      headers: authHeader(),
      params: {
        userId: userId,
        offset: paymentCurrentpage,
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setpaymentDetails(data);
        setpaymentDetailsCount(totalCount);
      }
    } catch (error) {
     
    } finally {
      setLoading(false);
    }
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const Back = () => {
    history(-1);
  };
  let Profile = () => {
    if (details.profileImage) {
      return details.profileImage;
    } else {
      return defaultAvatar;
    }
  };

  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };
  const onPaymentPageChange = (page) => {
    setpaymentCurrentpage(page - 1);
  };
  const first_name_Last_name = () => {
    if (!details.firstName && !details.lastName) {
      return <h4>N/A</h4>;
    } else {
      return (
        <>
          <h4>
            {details.firstName} {details.lastName}
          </h4>
        </>
      );
    }
  };



  useEffect(() => {
    GetUser();
    GetCustomer();
    GetPayment();
  }, [currentpage, paymentCurrentpage]);

  return (
    <div>
      {loading && <CustomPageLoading />}
      <div className="agency-wrapper">
        <Container fluid>
          <div className="page-title">
            <h4>Customer Details</h4>
            <div className="top-btn">
              <Button onClick={Back} color="primary">
                <BackButtonSvg />
                Back
              </Button>
            </div>
          </div>

          <Row className="mt-4">
            <Col xl="5">
              <Row>
                <Col md="12">
                  <Card body>
                    <div className="customer-name">
                      <img src={Profile()} alt=""/>

                      <div className="name">
                        {first_name_Last_name()}
                        <Badge color="primary">{details.email}</Badge>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col md="12">
                  <Card body>
                    <div className="customer-personal-info">
                      <Row>
                        <Col md="6">
                          <div className="info">
                            <span>FIRST NAME</span>
                            <p>
                              {details.firstName ? details.firstName : "N/A"}
                            </p>
                          </div>

                          <div className="info">
                            <span>EMAIL</span>
                            <p>{details.email ? details.email : "N/A"}</p>
                          </div>

                          <div className="info">
                            <span>GENDER</span>
                            <p>{details.gender ? details.gender : "N/A"}</p>
                          </div>

                          <div className="info">
                            <span>ADDRESS</span>
                            <p>{details.address ? details.address : "N/A"}</p>
                          </div>

                          <div className="info">
                            <span>STATE</span>
                            <p>
                              {details.stateName ? details.stateName : "N/A"}
                            </p>
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="info">
                            <span>LAST NAME</span>
                            <p>{details.lastName ? details.lastName : "N/A"}</p>
                          </div>
                          <div className="info">
                            <span>PHONE</span>
                            <p>
                              {details.phoneNumber
                                ? `+1 ${details.phoneNumber}`
                                : "N/A"}
                            </p>
                          </div>
                          {/* <div className="info">
                            <span>DOB</span>
                            <p>
                              {details.dateOfBirth
                                ? details.dateOfBirth
                                : "N/A"}
                            </p>
                          </div> */}
                          <div className="info">
                            <span>CITY</span>
                            <p>{details.city ? details.city : "N/A"}</p>
                          </div>
                          <div className="info">
                            <span>ZIP</span>
                            <p>{details.zip ? details.zip : "N/A"}</p>
                          </div>
                        </Col>
                      </Row>

                      <Row className="mt-5">
                        <Col sm="6" className="user-dash-count border-right">
                          <div className="bg">
                            <p>Total License</p>
                            <div className="count">
                              <h4>{details.totalLicense}</h4>
                            </div>
                          </div>
                        </Col>
                        <Col sm="6" className="user-dash-count">
                          <div className="bg">
                            <p>Total Paid Amount</p>
                            <div className="count">
                              <h4>
                                ${" "}
                                {parseInt(details.totalPaidAmount || 0).toFixed(
                                  2
                                )}
                              </h4>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Col>
                <Col md="12"></Col>
              </Row>
            </Col>

            <Col xl="7">
              <div>
                <Nav tabs className="mt-lg-4">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => {
                        toggle("2");
                      }}
                    >
                      Licence
                      <Tooltip
                        isOpen={id === "guestlicence" && tooltipOpen}
                        target={"guestlicence"}
                        toggle={() => tooltiptoggle("guestlicence")}
                      >
                        View license details
                      </Tooltip>
                      <span id={"guestlicence"}>
                        <Info />
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => {
                        toggle("1");
                      }}
                    >
                      Dog
                      <Tooltip
                        isOpen={id === "dog" && tooltipOpen}
                        target={"dog"}
                        toggle={() => tooltiptoggle("dog")}
                      >
                        View dog information
                      </Tooltip>
                      <span id={"dog"}>
                        <Info />
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "3" })}
                      onClick={() => {
                        toggle("3");
                      }}
                    >
                      Transaction
                      <Tooltip
                        isOpen={id === "guesttran" && tooltipOpen}
                        target={"guesttran"}
                        toggle={() => tooltiptoggle("guesttran")}
                      >
                        View transaction history
                      </Tooltip>
                      <span id={"guesttran"}>
                        <Info />
                      </span>
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="2">
                    <Card body className="mt-4">
                      {!Delete && (
                        <Link to={`${GUEST_USER_LICENSE}/${userId}`}>
                          <div className="create-license-btn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="63"
                              height="59"
                              viewBox="0 0 63 59"
                            >
                              <g
                                id="Group_115"
                                data-name="Group 115"
                                transform="translate(0.099)"
                              >
                                <rect
                                  id="Rectangle_1113"
                                  data-name="Rectangle 1113"
                                  width="59"
                                  height="59"
                                  rx="29.5"
                                  transform="translate(-0.099)"
                                  fill="#1b3e6f"
                                />
                                <path
                                  id="Icon_awesome-dog"
                                  data-name="Icon awesome-dog"
                                  d="M26.905,5.722H23.434l-.388-.776a1.736,1.736,0,0,0-1.552-.96H18.584L17.1,2.506a.868.868,0,0,0-1.482.614v8.128l6.943,2.48V11.8H24.3a3.471,3.471,0,0,0,3.472-3.472V6.59A.868.868,0,0,0,26.905,5.722Zm-6.075,2.6a.868.868,0,1,1,.868-.868A.868.868,0,0,1,20.83,8.325ZM5.207,12.665a1.738,1.738,0,0,1-1.736-1.736,1.736,1.736,0,0,0-3.472,0,5.2,5.2,0,0,0,3.472,4.887v11.6a.868.868,0,0,0,.868.868H7.811a.868.868,0,0,0,.868-.868V21.344h8.679V27.42a.868.868,0,0,0,.868.868H21.7a.868.868,0,0,0,.868-.868V15.57l-8.134-2.9Z"
                                  transform="translate(15.896 14.487)"
                                  fill="#fff"
                                />
                                <circle
                                  id="Ellipse_19"
                                  data-name="Ellipse 19"
                                  cx="10"
                                  cy="10"
                                  r="10"
                                  transform="translate(42.901 39)"
                                  fill="#dae0e8"
                                />
                                <path
                                  id="Icon_ionic-ios-add"
                                  data-name="Icon ionic-ios-add"
                                  d="M17.12,12.772H13.855V9.506a.541.541,0,1,0-1.083,0v3.266H9.506a.541.541,0,0,0,0,1.083h3.266V17.12a.541.541,0,1,0,1.083,0V13.855H17.12a.541.541,0,1,0,0-1.083Z"
                                  transform="translate(40.068 35.908)"
                                  fill="#1b3e6f"
                                />
                              </g>
                            </svg>

                            <h4>Get New License</h4>
                          </div>
                        </Link>
                      )}
                      <Row className="mt-4">
                        {licenseDetails.length === 0 ? (
                          <CustomTableEmptyRecord />
                        ) : (
                          <>
                            {licenseDetails.map((lic) => (
                              <Col md="6" lg="6" xl="6" className="mb-3">
                                <div className="license-box">
                                  <h4>{lic.typeofLicense}</h4>

                                  <div className="mt-4">
                                    <div>
                                      <div className="row align-items-center">
                                        <div className="col">
                                          <h6 className="text-sm mb-0">
                                            validate from
                                          </h6>
                                        </div>
                                        <div class="col-auto">
                                          <span className="text-sm">
                                            {lic.validFromDate}
                                          </span>
                                        </div>
                                      </div>
                                      <hr className="my-2" />
                                      <div className="row align-items-center">
                                        <div className="col">
                                          <h6 className="text-sm mb-0">
                                            validate To
                                          </h6>
                                        </div>
                                        <div class="col-auto">
                                          <span className="text-sm">
                                            {lic.validToDate}
                                          </span>
                                        </div>
                                      </div>
                                      <hr className="my-2" />
                                      <div className="row align-items-center">
                                        <div className="col">
                                          <h6 className="text-sm mb-0">
                                            Created date
                                          </h6>
                                        </div>
                                        <div className="col-auto">
                                          <span className="text-sm">
                                            {lic.createdDate}
                                          </span>
                                        </div>
                                      </div>
                                      <hr className="my-2" />
                                    </div>
                                  </div>

                                  <Badge
                                    className={
                                      lic.licenseStatus === "License Issued"
                                        ? "badge-pay-complete"
                                        : lic.licenseStatus === "Pending"
                                        ? "badge-success-pen"
                                        : lic.licenseStatus ===
                                          "License Approved"
                                        ? "badge-success-apr"
                                        : lic.licenseStatus === "Rejected"
                                        ? "badge-danger-soft"
                                        : lic.licenseStatus ===
                                          "Payment Completed"
                                        ? "badge-primary-soft"
                                        : lic.licenseStatus ===
                                          "License Generated"
                                        ? "badge-success-gen"
                                        : lic.licenseStatus === "Cancelled"
                                        ? "badge-danger-soft"
                                        : ""
                                    }
                                  >
                                    {lic.licenseStatus}
                                  </Badge>

                                  <div className="centerBtn">
                                    <Link
                                      to={{
                                        pathname: `${"/agency/view-license"}/${
                                          lic.licensePlanId
                                        }/${lic.dogLicenseId}`,
                                      }}
                                    >
                                      <Button color="primary" size="sm">
                                        View
                                      </Button>
                                    </Link>
                                  </div>
                                </div>
                              </Col>
                            ))}
                          </>
                        )}
                      </Row>
                    </Card>
                    <div className="d-flex flex-row py-4 justify-content-end">
                      <Pagination
                        itemClass="page-item"
                        linkClass="page-link"
                        activePage={currentpage + 1}
                        itemsCountPerPage={10}
                        totalItemsCount={licensetotalrecords}
                        onChange={onPageChange}
                      />
                    </div>
                  </TabPane>
                  <TabPane tabId="1">
                    <MyDog userId={userId} />
                  </TabPane>
                  <TabPane tabId="3">
                    <Card body className="mt-4">
                      <Table hover responsive>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Plan Name</th>
                            <th>Date</th>
                            <th>Payment Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paymentDetails.length === 0 ? (
                            <tr>
                              <td colSpan={4}>
                                <center>No Records Found</center>
                              </td>
                            </tr>
                          ) : (
                            <>
                              {paymentDetails.map((pay, index) => (
                                <tr>
                                  <td>{index + 1}</td>
                                  <td>{pay.planName}</td>
                                  <td>{pay.paymentDate}</td>
                                  <td>
                                    {" "}
                                    ${" "}
                                    {parseFloat(pay.totalAmount || 0).toFixed(
                                      2
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </>
                          )}
                        </tbody>
                      </Table>
                    </Card>
                    <div className="d-flex flex-row py-4 justify-content-end">
                      <Pagination
                        itemClass="page-item"
                        linkClass="page-link"
                        activePage={paymentCurrentpage + 1}
                        itemsCountPerPage={10}
                        totalItemsCount={paymentDetailsCount}
                        onChange={onPaymentPageChange}
                      />
                    </div>
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default GuestDetails;
